export class StrutturaFascicoloDTO {
    cmu: string;
    nome: string;
}